// Con la placa se distinguen dos motos de la misma marca y modelo.
export const vehicleName = (vehicle) => {
  const label = vehicle?.label?.trim() || 'Tu vehículo'
  const plate = vehicle?.Placa || vehicle?.placa
  return plate ? `${label} (${plate})` : label
}

const vehicleChasis = (vehicle) => vehicle?.Chasis || vehicle?.chasis

const EVENT_MESSAGES = {
  alarm: {
    title: 'Alarma en tu vehículo',
    body: (name) => `${name} reportó una alarma.`,
    tag: 'alarm',
  },
  turnOn: {
    title: 'Vehículo encendido',
    body: (name) => `${name} se encendió.`,
    tag: 'status',
  },
  turnOff: {
    title: 'Vehículo apagado',
    body: (name) => `${name} se apagó.`,
    tag: 'status',
  },
}

export const buildVehicleNotification = ({ type, vehicle }) => {
  const message = EVENT_MESSAGES[type]
  if (!message) return null
  return {
    title: message.title,
    body: message.body(vehicleName(vehicle)),
    tag: `${message.tag}-${vehicleChasis(vehicle)}`,
  }
}

export const testNotification = {
  title: 'Notificaciones activadas',
  body: 'Te avisaremos cuando tu vehículo se encienda, se apague o reporte una alarma.',
  tag: 'test',
}

// Tipo de aviso para el panel: los mensajes del backend son texto libre
// ("Su moto ... se encuentra encendida"), así que se reconoce por palabras clave.
export const NOTIFICATION_KIND_LABELS = {
  on: 'Moto encendida',
  off: 'Moto apagada',
  alarm: 'Alarma',
}

const KIND_BY_EVENT = { turnOn: 'on', turnOff: 'off', alarm: 'alarm' }

export const eventKind = (type) => KIND_BY_EVENT[type] || 'other'

export const notificationKind = (text = '') => {
  const normalized = text.toLowerCase()
  if (/alarma|alerta/.test(normalized)) return 'alarm'
  if (/apagad/.test(normalized)) return 'off'
  if (/encendid/.test(normalized)) return 'on'
  return 'other'
}
